/* eslint-disable max-len */
import { ExpressBookingReviewDetails, PetAvatars, UserContactInfoCard } from "../../../components";
import { Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

/* eslint-disable operator-linebreak */
import {
  BookingWhenContainer,
} from "./BookingReviewStyle";
import NewEditIcon from "../../../components/Icons/NewEditIcon";
import PromoCodeApply from "./PromoCodeApply";
import { fromUnixToFullDateNum } from "../../../utils/unix-timestamp";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { CalendarIcon, ExpressServiceAddressIcon, VerticalDivider } from "../../../components/Icons";
import { formatPetNames } from "../../../components/AvailableTimeSlots/ExpressAvailableTimeSlots";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";
import { getBookingMonth } from "../../../utils/bookingFlow";

type IBookingProps = {
  activeStep?: number;
  newUserBooking?: boolean | undefined;
  selectedSlot: string;
  setActiveStep: (val: number) => void
  setReasonUpdatePetIndex: (index: number) => void;
};

export const getExpressFormatSocString = (socReasons: string[], reasonTypeText?: string) => {
  const formattedHTML: JSX.Element[] = [];

  socReasons.map((reasons, i) => {
    const splitReasons = reasons.split(":");

    if (splitReasons.length > 1) {
      formattedHTML.push(<React.Fragment key={i}>
        <span className="font-semibold capitalize">
          {splitReasons[0] == "reasons" ? "Other": splitReasons[0]}:
        </span>
        <span className="font-normal"><br />{splitReasons[1].replaceAll(",", ", ")}</span>
        <br />
        {i !== socReasons.length-1 && <Divider className="!opacity-100 !my-0.5" />}
      </React.Fragment>);
    } else if (splitReasons.length == 1) {
      formattedHTML.push(<React.Fragment key={i}>
        <span className="font-semibold capitalize">{reasonTypeText ? reasonTypeText : "Express Services:"}<br /></span>
        <span className="font-normal">{splitReasons[0].replaceAll(",", ", ")}</span>
        <br />
      </React.Fragment>);
    }
  });

  return formattedHTML;
};

export const getFormattedReasons = (reasons: string) => {
  return reasons.split(",").join(", ");
};


const ExpressBookingReviewContainer = (props: IBookingProps) => {
  const { selectedSlot, setActiveStep, setReasonUpdatePetIndex } = props;
  const { appointmentForm, selectedPets, setAppointmentsForm } =
    useAppointmentStore();
  const { user } = useUserStore();
  const [bookingDate, setBookingDate]=useState<string>("");

  const [availableDate, setAvailableDate]=useState< {
    weekday: string;
    month: string;
    day: string;
    year: string;
    time: string;
}>();

  const handleEditTimeSlot = ()=>{
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_EDIT_DETAILS,
      { pet_name: selectedPets.map((pet) => pet.name).join(","),
        type: "edit_timeslot",
        appt_type: "express_visit",
      });
    setAppointmentsForm(null);
    setActiveStep(2);
  };


  useEffect(()=>{
    userActivityLogger(MIXPANEL_EVENTS.EXPRESS_SERVICE_REVIEW_CONFIRM,
      { appointment_category: "tech",
        pet_name: selectedPets.map((pet) => pet.name).join(","),
        date: appointmentForm?.day,
        time_slot: appointmentForm?.selectedSlotLabel,
        no_of_pets: selectedPets.length,
      });
  }, []);

  useEffect(()=>{
    if (appointmentForm?.time) {
      const availableDate = fromUnixToFullDateNum(+appointmentForm?.time!, "UTC");

      setAvailableDate(availableDate);
      setBookingDate(`${availableDate.month} ${availableDate.day} ${availableDate.year} `);
    }
  }, [appointmentForm?.time]);


  return (
    <div className="w-full flex flex-col gap-3 pb-2  p-4 border border-taupe-50 rounded-xl">
      <div className="flex gap-2 justify-between items-center">
        <div className="text-lg font-semibold w-4/6">
          {`Let’s confirm 
          ${formatPetNames(selectedPets.map((pet, index)=>pet.name ))}  visit at:`}
        </div>
        <PetAvatars
          height={50}
          width={50}
          petDetails={selectedPets} />
      </div>
      <div className="flex p-3 gap-2 bg-taupe-15 rounded-lg">
        <div className="pt-0.5">
          <ExpressServiceAddressIcon />
        </div>
        <div className="flex flex-col gap-0.5 text-sm">
          <div className="capitalize font-semibold">{`Goodvets ${user?.location?.locationName}`}</div>
          <div>{user?.location?.address}</div>
        </div>
      </div>
      <div>
        <Typography variant="body1" className="!font-bold text-sm" gutterBottom>
          Scheduled For
        </Typography>
        <BookingWhenContainer>
          <div className="flex justify-between w-full">
            <div className="flex gap-4 items-center">
              <CalendarIcon width={24} height={24} color="black" />
              <div>
                <span className="font-semibold flex gap-1 py-3 text-sm items-center flex-wrap">
                  {availableDate?.weekday}
                  <VerticalDivider />
                  {appointmentForm && appointmentForm?.time && `${getBookingMonth(appointmentForm.time)} ${bookingDate.split(" ")[1]}`}{" · "}
                  {selectedSlot?.toUpperCase()}
                </span>
              </div>
            </div>
            <div
              className="grow flex justify-end items-center mt-1 cursor-pointer"
              onClick={handleEditTimeSlot}
            >
              <NewEditIcon width={18} height={18} />
            </div>
          </div>

        </BookingWhenContainer>
      </div>
      <div></div>
      <div>
        <Typography variant="body1" className="!font-bold text-sm" gutterBottom>
            Reason for Visit
        </Typography>
        <ExpressBookingReviewDetails
          setActiveStep={setActiveStep}
          modal="BookingReview"
          setReasonUpdatePetIndex={setReasonUpdatePetIndex}
        />
      </div>
      <div>
        <Typography variant="body1" className="!font-bold text-sm" gutterBottom>
            Your Contact Information
        </Typography>
        {user &&
            <UserContactInfoCard
              userFirstName={user.firstName}
              userLastname={user.lastName}
              userEmail={user.email}
              userPhoneNumber={user.phone}
            />
        }
      </div>

      <div className="border-b-2 border-gray-3 w-full"></div>
      {/* PromoCode Apply Component */}
      <PromoCodeApply />
    </div>
  );
};

export default ExpressBookingReviewContainer;
